import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-inventario-paid',
  templateUrl: './inventario-paid.component.html',
  styleUrls: ['./inventario-paid.component.scss']
})
export class InventarioPaidComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
